var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "py-3" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col sm:flex-row sm:justify-between mb-1 gap-4 items-start",
        },
        [
          _c("div", { staticClass: "flex" }, [_vm._t("filters")], 2),
          _c("div", [_vm._t("actions")], 2),
        ]
      ),
      _vm.total
        ? _c("TotalCounter", {
            staticClass: "my-4",
            attrs: { total: _vm.total },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }